import { onLCP, onINP, onCLS, onTTFB } from 'web-vitals';
import { getMetrics } from './metrics';

export function reportWebVitals(): void {
  const m = getMetrics();

  onLCP(metric => {
    m.pageLcpMs.record(metric.value);
  });

  onINP(metric => {
    m.pageInpMs.record(metric.value);
  });

  onCLS(metric => {
    m.pageCls.record(metric.value);
  });

  onTTFB(metric => {
    m.pageTtfbMs.record(metric.value);
  });
}
